import { OriginalPermission } from './consultant.model';

export class IAppConfig {
  PRODUCTION: boolean;
  ENVIRONMENT_ID: number;
  LANGUAGES: [];
  API: string;
  HOME: string;
  EVALUALIA: string;
  MYRANDSTAD: string;
  ACCESS_PERMISSION: number;
  ALL_PERMISSIONS: OriginalPermission;
  LOGOUT_FBI: string;
  OFFICES_WITH_PROJECTS: string;
  SIZE_ARRAY_IN_GROUP: number;
  PERMISSIONS_MANAGER: string;
  GOOGLE_ACCOUNT: string;
  RAAS_BASE_URL: string;
  RAAS_CLIENT_ID: string;
}

export class AppVersionModel {
  appName: string;
  version: string;
}
